module.exports = __webpack_public_path__ + "static/media/marker.fbe33f21.png";